import { render, staticRenderFns } from "./layout-support-entry.vue?vue&type=template&id=48c8efce&scoped=true&"
import script from "./layout-support-entry.vue?vue&type=script&lang=js&"
export * from "./layout-support-entry.vue?vue&type=script&lang=js&"
import style0 from "./layout-support-entry.vue?vue&type=style&index=0&id=48c8efce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c8efce",
  null
  
)

export default component.exports